export function animateAppearance(
    containerEl: HTMLElement | SVGElement | null,
    type: "appear" | "disappear",
): Animation | undefined {
    if (!containerEl) {
        return;
    }

    const direction = type === "appear" ? "normal" : "reverse";

    return containerEl.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 500,
        easing: "ease-in-out",
        fill: "both",
        direction,
    });
}
